const LOCALE_INDEX = 1;

export function buildLocaleRedirectUrl(location, defaultLanguage) {
  const pathSegments = location.pathname.split('/');
  pathSegments[LOCALE_INDEX] = defaultLanguage;
  return (
    location.origin + pathSegments.join('/') + location.search + location.hash
  );
}
